import React from 'react';
import { FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

export const TextFields = ({ fieldName, displayName }) => {
    const { visualObject, setVisualObject } = useVisualFormContext();
    if (!visualObject) return null;
    return (
        <FieldControl
            fieldMetadata={{
                FieldType: SystemTypes.UIFieldType.TextBox,
                FieldName: fieldName,
                DisplayName: displayName,
            }}
            groupId={"visual"}
            value={visualObject[fieldName] ?? ''}
            onChange={v => {
                setVisualObject(prev => ({
                    ...prev,
                    [fieldName]: v,
                }));
            }}
        />
    );
};